import _isNumber from "lodash/isNumber";
import { getPlayingAgeLabel } from "shared-utils";
import {
  FiltersFieldNames,
  IFilterFieldConfig,
  IFilterValues,
} from "../../types";
import { RangeSelectionDropdown } from "../../../../Molecules/RangeSelectionDropdown/RangeSelectionDropdown";
import RangeSelection from "../../../../Molecules/RangeSelection";
import getPlayingAgePillTitle from "./helpers/getPlayingAgePillTitle";
import { FEATURE_FLAGS } from "shared-services";
import { PlayingAge } from "shared-types";

export const playingAgeFilter: IFilterFieldConfig<IFilterValues> = {
  name: FiltersFieldNames.PlayingAge,
  defaultValue: {},
  modifiers: { showFilterControl: true },
  getFilterFiledProps: ({
    values,
    filterDrawerValues,
    setFilterValues,
    setFilterDrawerValues,
    modifiers,
    t,
    flags = {},
  }) => {
    const isYPPlayingAgeEnabled = flags[FEATURE_FLAGS.YPsPlayingAgeMin];
    const upperRangeMinOverride = isYPPlayingAgeEnabled ? 1 : undefined;

    const playingAgeFilterTexts = {
      topmostDropdownPlaceholder: t("common:label.playingAge"),
      lowerDropdownPlaceholder: t("common:label.select"),
      lowerDropdownLabel: t("common:label.from"),
      upperDropdownPlaceholder: t("common:label.select"),
      upperDropdownLabel: t("common:label.to"),
    };

    const filterControlComponent = modifiers?.showFilterControl ? (
      <RangeSelectionDropdown
        minimumRangeValue={
          isYPPlayingAgeEnabled
            ? PlayingAge.YPPlayingAgeMinYrs
            : PlayingAge.PlayingAgeMinYrs
        }
        upperRangeMinOverride={upperRangeMinOverride}
        maximumRangeValue={PlayingAge.PlayingAgeMaxYrs}
        value={values[FiltersFieldNames.PlayingAge]}
        content={playingAgeFilterTexts}
        getValueRepresentation={(value) => getPlayingAgeLabel(value, t)}
        valueChanged={(value) => {
          setFilterValues({
            [FiltersFieldNames.PlayingAge]: value,
          });
        }}
        key={FiltersFieldNames.PlayingAge}
      />
    ) : null;

    const playingAgeValue = Object(values[FiltersFieldNames.PlayingAge]);
    const playingAgeIsSelected =
      _isNumber(playingAgeValue.lowerRangeValue) ||
      _isNumber(playingAgeValue.upperRangeValue);

    const filterDrawerConfig = {
      title: t("common:label.playingAge"),
      id: FiltersFieldNames.PlayingAge,
      selected: playingAgeIsSelected,
      renderFilterContent: () => (
        <RangeSelection
          value={filterDrawerValues[FiltersFieldNames.PlayingAge]}
          content={playingAgeFilterTexts}
          getValueRepresentation={(value) => getPlayingAgeLabel(value, t)}
          minimumRangeValue={
            isYPPlayingAgeEnabled
              ? PlayingAge.YPPlayingAgeMinYrs
              : PlayingAge.PlayingAgeMinYrs
          }
          upperRangeMinOverride={upperRangeMinOverride}
          maximumRangeValue={PlayingAge.PlayingAgeMaxYrs}
          valueChanged={(value) => {
            setFilterDrawerValues({
              [FiltersFieldNames.PlayingAge]: value,
            });
          }}
        />
      ),
    };

    const tags = playingAgeIsSelected
      ? [
          {
            id: `${FiltersFieldNames.PlayingAge}`,
            text: getPlayingAgePillTitle({
              lowerRangeValue: playingAgeValue.lowerRangeValue,
              upperRangeValue: playingAgeValue.upperRangeValue,
              t,
            }),
            onClick: () => {
              setFilterValues({
                [FiltersFieldNames.PlayingAge]: {},
              });
            },
          },
        ]
      : [];

    return {
      tags,
      filterDrawerConfig,
      filterControlComponent,
    };
  },
};
